export const GITHUB_COOKIE_KEY = '__gh';
export const REF_COOKIE_KEY = 'ref';
export const GITHUB_EMULATOR_TOKEN = 'supabaseEmulatorGHToken';

// Meta Pixel / CAPI tracking
export const META_COOKIE_FBC = '_fbc';
export const META_COOKIE_FBP = '_fbp';
export const META_URL_PARAM_FBCLID = 'fbclid';
